export default __webpack_public_path__ + "static/media/list-reward-ref.5170bd17.svg";